import { ArrowDownRight, FileSpreadsheet, Workflow, ChartNoAxesCombined } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { BUSINESS_PATHS } from "@/lib/businessPaths";

const ICONS = [FileSpreadsheet, Workflow, ChartNoAxesCombined];

export const BusinessPathsSection = () => {
  const { t } = useLang();
  const copy = t.businessPaths;
  return (
    <section id="loesninger" aria-labelledby="business-paths-title" className="relative border-b border-[var(--line)] py-12 lg:py-16" data-testid="business-paths-section">
      <div className="mx-auto max-w-7xl px-5">
        <h2 id="business-paths-title" className="font-display text-base md:text-lg font-semibold text-white" data-testid="business-paths-title">{copy.title}</h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-muted" data-testid="business-paths-intro">{copy.intro}</p>
        <div className="mt-8 grid gap-6 md:grid-cols-[1.2fr_1fr_1fr] md:gap-8" data-testid="business-paths-grid">
          {BUSINESS_PATHS.map((path, index) => {
            const item = copy.items[index];
            const Icon = ICONS[index];
            return (
              <a key={path.key} href={`#${path.serviceId}`} className={`group flex min-w-0 flex-col border-t-2 py-5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--cyan)] hover:border-[var(--cyan)] ${index === 0 ? "border-[var(--cyan)]" : "border-[var(--line-strong)]"}`} data-testid={`business-path-${path.key}`}>
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-[10px] uppercase text-[var(--muted-2)]" data-testid={`business-path-tag-${path.key}`}>{index === 0 ? copy.specialty : copy.supporting}</span>
                  <Icon size={21} className={index === 0 ? "text-[var(--cyan)]" : "text-[var(--green)]"} aria-hidden="true" />
                </div>
                <h3 className="mt-4 font-display text-xl font-semibold text-white" data-testid={`business-path-title-${path.key}`}>{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-testid={`business-path-description-${path.key}`}>{item.desc}</p>
                <span className="mt-auto flex items-center gap-2 pt-5 text-sm font-medium text-[var(--cyan)]" data-testid={`business-path-link-label-${path.key}`}>
                  {item.cta}<ArrowDownRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1" aria-hidden="true" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};